import { CHANGE_LOCALE } from './../constants';

export const changeLocale = (value) => dispatch => {
  dispatch ({
    type: CHANGE_LOCALE,
    payload: value
  });
}
